module.exports = {
  NODE_ENV: JSON.stringify("production"),
  FACEBOOK_APP_ID: "339067529946075",
  GTAG_APP_ID: "UA-178138162-1",
  PAYMENT_API_URL: "https://payment-api.plus.gamedistribution.com",
  PLAY_API_URL: "https://play-api.plus.gamedistribution.com",
  CONFIG_API_URL: "https://config-api.plus.gamedistribution.com/game/frontend",
  ASSET_URL: "https://assets.plus.gamedistribution.com",
  NETWORK_URL: "https://network.plus.gamedistribution.com",
  SDK_URL: "https://assets.plus.gamedistribution.com/sdk/main.js",
  AZC_AUTH_URL: "https://idp.azerionconnect.com/auth",
  AZC_AUTH_CLIENT_ID: "2669bfaa-7db1-4fd2-bf59-8d9e27b5ae20",
  AZC_ACCOUNT_URL: "https://myaccount.azerionconnect.com",
  PRIVACY_POLICY_URL: "https://www.plinga.com/corporate/privacy-policy/",
  TERMS_OF_SERVICE_URL: "https://www.plinga.com/corporate/terms-of-service/"
};
